import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ExternalMatchRequestRule } from 'generated/graphql';

interface RulesContextType {
  rules: ExternalMatchRequestRule[];
  setRules: (rules: ExternalMatchRequestRule[]) => void;
}

const RulesContext = createContext<RulesContextType | undefined>(undefined);

interface RulesProviderProps {
  children: ReactNode;
}

export const RulesProvider: React.FC<RulesProviderProps> = ({ children }) => {
  const [rules, setRulesState] = useState<ExternalMatchRequestRule[]>([]);

  const setRules = (newRules: ExternalMatchRequestRule[]) => {
    setRulesState(newRules);
  };

  return <RulesContext.Provider value={{ rules, setRules }}>{children}</RulesContext.Provider>;
};

export const useRulesContext = (): RulesContextType => {
  const context = useContext(RulesContext);
  if (context === undefined) {
    throw new Error('useRulesContext must be used within a RulesProvider');
  }
  return context;
};
